module.exports = __webpack_public_path__ + "static/media/CHAWL_MENU-normal.145c46bc.png";